<div class="app-wrapper" 
     [class.guest]="(sm.getUserRoleObservable() | async) === 'guest'"
     [class.auth]="!(sm.getUserObservable() | async)?.accessToken"
     [class.project-status-prevention]="projectStatusPrevention"
     [class.project-status-full-prevention]="projectStatusFullPrevention">
  <div id="forcespinner" class="force-spinner">
    <app-spinner></app-spinner>
  </div>
  <top-logo-bar></top-logo-bar>
  <router-outlet></router-outlet>
  <ops-subscription-modal-wrapper></ops-subscription-modal-wrapper>
</div>
